const domainStage = 'api.give543.com'
const qaServer = 'qa-api.give543.com'

function getDomain () {
  if (/m\.give543\.com/.test(window.location.href) ||
    /m\.give-circle\.com/.test(window.location.href)) {
    return domainStage
  } else if (/m\.qa\.give543\.com/.test(window.location.href)) {
    return qaServer
  } else {
    return qaServer
  }
}
export const domain = getDomain()

export const showOpenApp = true
// APP 內執行時（Cordova WebView）window.cordova 會被注入
export const IN_APP = typeof window !== 'undefined' && !!(window.cordova || window.Cordova)

export const NEED_COUNT_LIMIT = {
  MAX_NORMAL: 50,
  MAX_COMMONWEAL: 500,
  MAX_TOTAL_NORMAL: 250,
  MAX_TOTAL_COMMONWEAL: 2500
}

export const SHOW_RATE_DIALOG_MAX_OPERATION = 5

export const PLATFORM_NEED_SHOW_RATE_DIALOG = false
export const PLATFORM_SHOW_DEACTIVATE = false

export const storeUrl = (function () {
  if (/android/i.test(navigator.userAgent)) {
    return 'https://play.google.com/store/apps/details?id=com.give543.application'
  } else {
    return 'itms-apps://itunes.apple.com/WebObjects/MZStore.woa/wa/viewContentsUserReviews?type=Purple+Software&id=1433535336'
  }
}())

export const PLATFORM = 'Mobile'

export const FESTIVAL_EARTH_DAY_ID = 7
export const FESTIVAL_SOCIAL_WORK_DAY_2025 = 13
export const FESTIVAL_EARTH_2024 = 12
export const FESTIVAL_EARTH_2025 = 14
export const FESTIVAL_SOCIAL_WORK_DAY_2026 = 15
export const FESTIVAL_EARTH_2026 = 16
export const WELFARE_AWARD_YEAR = 2022

export const FLOWER_RECORD_TYPE = {
  TYPE_GAIN: 1,
  TYPE_EXPEND: 2
}

export const FLOWER_ATTAIN_WAY = {
  WAY_SIGN_IN: 1,
  WAY_ANSWER: 2,
  WAY_SHARE: 3,
  WAY_SYSTEM: 4
}

export const FLOWER_ATTAIN_TEXTS = {
  [FLOWER_ATTAIN_WAY.WAY_SIGN_IN]: '簽到',
  [FLOWER_ATTAIN_WAY.WAY_ANSWER]: '答題',
  [FLOWER_ATTAIN_WAY.WAY_SHARE]: '分享',
  [FLOWER_ATTAIN_WAY.WAY_SYSTEM]: '驚喜送花'
}

export const emojiList = [
  { codepoint: '1f600', unified: '😀' },
  { codepoint: '1f604', unified: '😄' },
  { codepoint: '1f601', unified: '😁' },
  { codepoint: '1f606', unified: '😆' },
  { codepoint: '1f605', unified: '😅' },
  { codepoint: '1f602', unified: '😂' },
  { codepoint: '1f642', unified: '🙂' },
  { codepoint: '1f60a', unified: '😊' },
  { codepoint: '1f607', unified: '😇' },
  { codepoint: '1f970', unified: '🥰' },
  { codepoint: '1f60d', unified: '😍' },
  { codepoint: '1f618', unified: '😘' },
  { codepoint: '1f60e', unified: '😎' },
  { codepoint: '1f633', unified: '😳' },
  { codepoint: '1f62d', unified: '😭' },
  { codepoint: '263a-fe0f', unified: '☺' },
  { codepoint: '1f61a', unified: '😚' },
  { codepoint: '1f61b', unified: '😛' },
  { codepoint: '1f61c', unified: '😜' },
  { codepoint: '1f61d', unified: '😝' },
  { codepoint: '1f917', unified: '🤗' },
  { codepoint: '1f612', unified: '😒' },
  { codepoint: '1f644', unified: '🙄' },
  { codepoint: '1f925', unified: '🤥' },
  { codepoint: '1f612', unified: '😒' },
  { codepoint: '1f614', unified: '😔' },
  { codepoint: '1f62a', unified: '😪' },
  { codepoint: '1f634', unified: '😴' },
  { codepoint: '1f637', unified: '😷' },
  { codepoint: '1f635', unified: '😵' },
  { codepoint: '1f631', unified: '😱' },
  { codepoint: '1f629', unified: '😩' },
  { codepoint: '1f621', unified: '😡' },
  { codepoint: '1f624', unified: '😤' },
  { codepoint: '1f4a9', unified: '💩' },
  { codepoint: '1f47b', unified: '👻' },
  { codepoint: '1f497', unified: '💗' },
  { codepoint: '1f49e', unified: '💞' },
  { codepoint: '1f49d', unified: '💝' },
  { codepoint: '1f496', unified: '💖' },
  { codepoint: '2764-fe0f', unified: '❤' },
  { codepoint: '1f494', unified: '💔' },
  { codepoint: '1f44c', unified: '👌' },
  { codepoint: '270c-fe0f', unified: '✌' },
  { codepoint: '1f44d', unified: '👍' },
  { codepoint: '1f44e', unified: '👎' },
  { codepoint: '1f44f', unified: '👏' },
  { codepoint: '1f91d', unified: '🤝' },
  { codepoint: '1f64f', unified: '🙏' },
  { codepoint: '1f389', unified: '🎉' },
  { codepoint: '1f38a', unified: '🎊' },
  { codepoint: '1f381', unified: '🎁' },
  { codepoint: '1f30f', unified: '🌏' },
  { codepoint: '1f648', unified: '🙈' },
  { codepoint: '1f649', unified: '🙉' },
  { codepoint: '1f64a', unified: '🙊' },
  { codepoint: '1f638', unified: '😸' },
  { codepoint: '1f639', unified: '😹' },
  { codepoint: '1f63b', unified: '😻' },
  { codepoint: '1f63d', unified: '😽' },
  { codepoint: '1f640', unified: '🙀' }
]
